module.exports = __webpack_public_path__ + "img/icon_holy_grail_loop.7283a1ae.gif";